/* eslint-disable no-console */
export const consoleSentry = {
  init: () => {},
  setUser: () => {},
  setTag: () => {},
  captureException: (exception) => console.log(exception),
  captureMessage: (message) => console.log(message),
  withScope: (callback) => callback({ setContext: () => {} }),
  addBreadcrumb: () => {},
  replayIntegration: () => ({}),
};
